import { Blocks } from 'lucide-react';

import { ControllerDisplayModeSupport } from './types';
import { DisplayMode } from '@rta/rta-blueprint-component';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { useSubscription } from '@rta/rta-blueprint-library';
import { Feature, FeatureHoookParams } from '..';

type UseDisplayManufacturingModeFeatureParams = FeatureHoookParams;
export const useDisplayManufacturingModeFeature = (_params: UseDisplayManufacturingModeFeatureParams = {}): Feature<boolean> => {
	const design = useDesign();
	const controller = design[0] as (typeof design[0]) & ControllerDisplayModeSupport;

	const controllerSupportsFeature = (controller?.navigation?.displayMode ?? null) !== null;
	const inManufacturingView = controller?.navigation?.displayMode === DisplayMode.Manufacturing;
	const inInlineView = controller?.navigation?.displayMode === DisplayMode.Inline;
	const inInlineManufacturingView = controller?.navigation?.displayMode === DisplayMode.InlineManufacturing;
	const inOverheadView = controller?.navigation?.displayMode === DisplayMode.Overhead;
	const inOverheadManufacturingView = controller?.navigation?.displayMode === DisplayMode.OverheadManufacturing;
	const inBacksplashView = controller?.navigation?.displayMode === DisplayMode.Backsplash;
	const inBacksplashManufacturingView = controller?.navigation?.displayMode === DisplayMode.BacksplashManufacturing;
	const inCornerTrimView = controller?.navigation?.displayMode === DisplayMode.CornerTrim;
	const inCornerTrimManufacturingView = controller?.navigation?.displayMode === DisplayMode.CornerTrimManufacturing;
	const inSkuOverheadView = controller?.navigation?.displayMode === DisplayMode.SkuOverhead;
	const inSkuOverheadManufacturingView = controller?.navigation?.displayMode === DisplayMode.SkuOverheadManufacturing;
	const inBlueprintView = controller?.navigation?.displayMode === DisplayMode.BlueprintView;

	useSubscription(controller, false, [['navigation-display-mode', '*']]);

	const [disabled, tooltip] = (() => {
		if (!controllerSupportsFeature) return [true, lang.navigation.tooltip.disabledNotSupportCurrentView];
		if (inBlueprintView) return [true, lang.navigation.tooltip.disabledNotSupportCurrentView];
		return [false, lang.navigation.tooltip.manufacturingMode];
	})();

	return {
		name: 'manufacturing-view',
		label: lang.navigation.label.manufacturingMode,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <Blocks color={inManufacturingView || inInlineManufacturingView || inOverheadManufacturingView || inBacksplashManufacturingView || inCornerTrimManufacturingView || inSkuOverheadManufacturingView ? 'green' : 'black'} {...props} />,
		disabled,
		value: inManufacturingView,
		hidden: false,
		handler: () => {
			if (controllerSupportsFeature) {
				if (inManufacturingView) {
					// revert to saved displayMode
					controller.navigation.displayMode = DisplayMode.Panel;
				} else if (inInlineView) {
					controller.navigation.displayMode = DisplayMode.InlineManufacturing;
				} else if (inInlineManufacturingView) {
					controller.navigation.displayMode = DisplayMode.Inline;
				} else if (inOverheadView) {
					controller.navigation.displayMode = DisplayMode.OverheadManufacturing;
				} else if (inOverheadManufacturingView) {
					controller.navigation.displayMode = DisplayMode.Overhead;
				} else if (inBacksplashView) {
					controller.navigation.displayMode = DisplayMode.BacksplashManufacturing;
				} else if (inBacksplashManufacturingView) {
					controller.navigation.displayMode = DisplayMode.Backsplash;
				} else if (inCornerTrimView) {
					controller.navigation.displayMode = DisplayMode.CornerTrimManufacturing;
				} else if (inCornerTrimManufacturingView) {
					controller.navigation.displayMode = DisplayMode.CornerTrim;
				} else if (inSkuOverheadView) {
					controller.navigation.displayMode = DisplayMode.SkuOverheadManufacturing;
				} else if (inSkuOverheadManufacturingView) {
					controller.navigation.displayMode = DisplayMode.SkuOverhead;
				} else {
					controller.navigation.displayMode = DisplayMode.Manufacturing;
				}
			}
			// console.log('viewMode', viewMode);
		}
	};
};
